<template>
  <div class="access__grid" :class="{'simple':isSimple}">
    <label :for="`cross-${type}-${product.id}`" :class="{'unavailable': outOfStock}">
      <input :id="`cross-${type}-${product.id}`" type="checkbox" :value="product.id"
             v-model.number="selected" :disabled="outOfStock">
      {{ sanitize(product.name) }}<span class="out-of-stock" v-if="outOfStock"> (rupture)</span>
    </label>
    <div><strong>{{ price }} €</strong></div>
    <select v-if="Object.hasOwn(product,'variations')" v-model="selectedVariationId">
      <option v-for="variation in product.variations" :value="variation.id">{{ variation.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "ProductPageDevisRow",
  props: ['product', 'type'],
  data() {
    return {
      selected: false, // array if simplest way to add the id
      selectedVariationId: null,
    }
  },
  watch: {
    selected(val) {
      const id = this.isSimple ? this.product.id : this.selectedVariationId
      if (val) {
        this.$emit('add-product', id);
        return
      }
      this.$emit('remove-product', id);
    },
  },
  computed: {
    isSimple() {
      return !Object.hasOwn(this.product, 'variations')
    },
    outOfStock() {
      if (this.isSimple) {
        return this.product.stock_quantity <= 0 && this.product.backorders === 'no'
      }
      if (this.selectedVariationId) {
        const variation = this.product.variations.find(variation => variation.id === this.selectedVariationId)
        return variation.stock_quantity <= 0 && variation.backorders === 'no'
      }
    },
    price() {
      if (this.isSimple) {
        return this.product.price
      }
      if (this.selectedVariationId) {
        const variation = this.product.variations.find(variation => variation.id === this.selectedVariationId)
        return variation.price
      }
    }
  },
  methods: {
    sanitize(string) {
      return string.replace('&amp;', '&')
    },
  },
  beforeMount() {
    if (this.product.variations) {
      this.selectedVariationId = this.product.variations[0].id
    }
    this.$watch('selectedVariationId', (val, oldVal) => {
      this.$emit('remove-product', oldVal);
      if (this.selected) {
        this.$emit('add-product', val);
      }
    })
  }
}
</script>


<style scoped lang="scss">
.access__grid { // div
  display: grid;
  grid-template-columns: 2fr 60px 1fr;
  grid-gap: 1rem;
  margin-bottom: 1rem;
  align-items: center;

  &.simple {
    grid-template-columns: 1fr 60px;
  }

  label {
    display: block;
    cursor: pointer;

    [type="checkbox"] {
      margin-right: .5rem;
      margin-bottom: 2px;
      vertical-align: middle;
    }

    &.unavailable {
      opacity: .4;

      label {
        cursor: not-allowed;
      }
    }
  }


  .out-of-stock {
    color: var(--red);
  }

  select {
    padding: 0 .5rem;
    height: 30px;
    font-size: 1.3rem;
    margin-bottom: 0;
  }
}

</style>
